"use client";
import {
  useDrawer
} from "./chunk-YU4W5PZD.mjs";

// src/drawer.tsx
import { forwardRef } from "@nextui-org/system";
import { Modal } from "@nextui-org/modal";
import { jsx } from "react/jsx-runtime";
var Drawer = forwardRef(({ children, ...props }, ref) => {
  const { domRef, getModalProps } = useDrawer({ ...props, ref });
  return /* @__PURE__ */ jsx(Modal, { ref: domRef, ...getModalProps(), children });
});
Drawer.displayName = "NextUI.Drawer";
var drawer_default = Drawer;

export {
  drawer_default
};
